enum CasinoSortEnum {
    None = "None",
    Name = "Name (A to Z)",
    Rating = "Rating (High to Low)",
    CrapsMinimumBet = "Craps Minimum Bet (Low to High)",
    BlackjackMinimumBet = "Blackjack Minimum Bet (Low to High)",
    RouletteMinimumBet = "Roulette Minimum Bet (Low to High)",
}

export default CasinoSortEnum;